import React, { createContext, useContext, useState, ReactNode } from 'react';
import { translations, Translations, Language, languages } from '../types/translations';

interface LanguageContextType {
    currentLanguage: Language;
    translations: Translations;
    setLanguage: (language: Language) => void;
    isRTL: boolean;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

interface LanguageProviderProps {
    children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
    const [currentLanguage, setCurrentLanguage] = useState<Language>(languages[0]); // Default to English

    const setLanguage = (language: Language) => {
        setCurrentLanguage(language);
        document.documentElement.lang = language.code;
        document.documentElement.dir = language.direction;
    };

    const value: LanguageContextType = {
        currentLanguage,
        translations: translations[currentLanguage.code],
        setLanguage,
        isRTL: currentLanguage.direction === 'rtl'
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = (): LanguageContextType => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};